import React from 'react'

function Loader() {
  return (
    <div className="loader" id="sk-loader" />
  )
}

export default Loader